import { useMemo } from "react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { getDesignById, HomepageDesign } from "@/data/homepageDesigns";

export const useHomepageDesign = (): {
  design: HomepageDesign;
  designId: number;
  loading: boolean;
} => {
  const { content, loading } = useSiteContent();
  const designId = parseInt(content.homepage_design || "1", 10) || 1;

  const design = useMemo(() => getDesignById(designId), [designId]);

  return { design, designId, loading };
};

/**
 * Returns font CSS variables for the active design.
 * Components use these via inline style or a wrapper.
 */
export const getDesignFontStyles = (
  design: HomepageDesign,
  overrides?: { heading?: string; ui?: string; body?: string }
): Record<string, string> => ({
  "--design-font-heading": overrides?.heading || design.fonts.heading,
  "--design-font-ui": overrides?.ui || design.fonts.ui,
  "--design-font-body": overrides?.body || design.fonts.body,
});
